import React from 'react';
import { IIconProps } from './utils';

export const StickPerson = ({
  fill = 'currentColor',
  height = 16,
  width = 13,
  ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 13 16" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M11.2753 4.35668C11.8952 4.21164 12.5168 4.59691 12.6626 5.21666C12.8078 5.83687 12.4226 6.45838 11.8026 6.60399L8.41948 7.39501C8.40744 7.39782 8.39509 7.40069 8.38297 7.40312C8.28142 7.42342 8.17934 7.44132 8.07737 7.45855V9.76399L10.7871 14.0991C11.1248 14.6394 10.9595 15.3513 10.4193 15.6892C9.87896 16.0269 9.16692 15.8631 8.82918 15.3228L6.3466 11.3501L3.86403 15.3228C3.5263 15.8631 2.81425 16.0269 2.27388 15.6892C1.73364 15.3513 1.56839 14.6394 1.90608 14.0991L4.61582 9.76399V7.45855C4.51382 7.44131 4.41184 7.42343 4.31024 7.40312C4.29807 7.40069 4.28583 7.39783 4.27373 7.39501L0.890617 6.60399C0.270501 6.45845 -0.114589 5.83692 0.0306298 5.21666C0.176389 4.59687 0.797875 4.21153 1.41795 4.35668L4.76863 5.14229C5.12356 5.213 5.48261 5.25904 5.84225 5.28157C6.17815 5.30258 6.51507 5.30258 6.85096 5.28157C7.21013 5.25907 7.56876 5.21285 7.92324 5.14229L11.2753 4.35668ZM6.34526 0C7.46022 0 8.36503 0.903899 8.36539 2.01878C8.36539 3.13398 7.46044 4.03893 6.34526 4.03893C5.23022 4.03873 4.32647 3.13386 4.32647 2.01878C4.32683 0.904023 5.23044 0.000195231 6.34526 0Z"
      fill={fill}
    />
  </svg>
);
